import * as ng from 'angular';
import {PreviewService} from '../../../services/preview.service';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {googleAPI} from '../../../third/googleAPI';
import {appContext} from '../../../app.context';
import {TableHeaderItem} from '../../../commons/components/table-component/domain/table-header-item';

class ArchidriveController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    '$uibModal',
    '$timeout',
    '$sce',
    'PreviewService',
  ];

  private headerColumns: Array<TableHeaderItem>;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $timeout: ng.ITimeoutService,
    private $sce: ng.ISCEService,
    private PreviewService: PreviewService,
  ) {

    /* tslint:disable:no-string-literal */
    $scope.pageHeader = 'Archivio di ';
    $scope.user = store.get('user');
    if ($scope.user.accountData.userType === 1) {
      $scope.pageHeader += $scope.user.organizationData.contactPerson.firstname;
    } else {
      $scope.pageHeader += $scope.user.organizationData.name;
    }

    this.headerColumns = [
      {key: 'nulla', label: '', ratio: '5', isSortable: false},
      {key: 'name', label: 'Nome', ratio: '45', isSortable: true},
      {key: 'size', label: 'Dimesione', ratio: '20', isSortable: true},
      {key: 'date', label: 'Data', ratio: '30', isSortable: true},
    ];

    // <editor-fold desc='Initialization'>
    $scope.tooltips = {
      'cerca': 'Cerca file o cartelle per nome o per data.',
      'carica': 'Carica un nuovo documento.',
      'scarica': 'Scarica un documento dall\'archivio.'
    };

    $scope.dipDescription = $sce.trustAsHtml('Questa è una cartella di servizio non cancellabile, nè modificabile. In questa cartella troverai i pacchetti che richiederai per la distribuzione ufficiale dei documenti conservati. I pacchetti di distribuzione possono essere richiesti e condivisi per l\'esibizione ufficiale dei documenti conservati[Ad Esempio ad un Pubblico Ufficiale]');
    $scope.moreDataToLoad = true;
    $scope.selectedItems = [];
    let processingRequest = false;

    $scope.clearSelection = () => {
      $scope.selectedItems = [];
      for (let i = 0; i < $scope.items.length; i++) {
        $scope.items[i].isSelected = false;
      }
      $scope.selectAllValue = false;
    };

    $scope.download = (itemScope) => {
      if (itemScope !== undefined) {
        $rootScope.downloadFile(itemScope.storage_path, itemScope.name);
      } else {
        if ($scope.selectedItems.length === 1) {
          let selectedItem = $scope.getItemByStoragePath($scope.selectedItems[0]);
          if (selectedItem.content_type !== 'application/x-www-form-urlencoded;charset=UTF-8') {
            $rootScope.downloadFile(selectedItem.storage_path, selectedItem.name);
          }
        } else {
          return;
        }
      }
    };


    let archiDriveRootPath = '';
    let archiDriveUploadRootPath = '';
    let getItems = (type?: any) => {
      if (processingRequest) {
        return;
      }
      if (type === 'newSearch') {
        $scope.settings.filter.pageNumber = 1;
      }
      processingRequest = true;
      ArchiSmallServices.listArchidriveDirectory($scope.settings.filter)
        .then((res: any) => {
          // if (appContext.userBrowser.isEdge) {
          // 	// $('.archidrive #table-items').css('display', 'none');
          // }
          // console.log(res);

          const response = JSON.parse(JSON.stringify(res));

          if (response.Result === 1) {
            $scope.settings.itemsCount = response.itemsCount;

            let items = response.resultList;
            $scope.items = items;
            $scope.moreDataToLoad = true;

            if ($scope.items.length >= $scope.settings.itemsCount) {
              $scope.moreDataToLoad = false;
            }
            // reset the selected item if is still present
            // addSelectedField($scope.items);
            archiDriveUploadRootPath = response.archiDriveRootPath.substr(response.archiDriveRootPath.indexOf('/') + 1);
            archiDriveRootPath = response.archiDriveRootPath.slice(0, -1);
            $scope.currentLocation = $scope.settings.filter.directory;
            $scope.breadcrumbs = [{
              'name': 'Archivia',
              'directory': '/',
              'root': archiDriveRootPath + '/',
            }];
            let path = '/';
            let splits = $scope.currentLocation.split('/');
            for (let i = 0; i < splits.length; i++) {
              if (splits[i] !== '') {
                path += splits[i] + '/';
                $scope.breadcrumbs.push({
                  'name': splits[i],
                  'directory': path,
                  'root': archiDriveRootPath + '/' + splits[i] + '/',
                });
                archiDriveRootPath += '/' + splits[i];
              }
            }
          }
          processingRequest = false;
        }, (error) => {
          $rootScope.alert('error', error);
          processingRequest = false;
        });
    };

    $scope.getItems = getItems;

    $scope.delete = (itemScope) => {
      if ($scope.selectedItems.length > 0 || itemScope !== undefined) {
        let selectedStoragePaths = [];
        let names = '';
        if (itemScope !== undefined) {
          selectedStoragePaths.push(itemScope._id + ':' + itemScope.is_folder);
          names = itemScope.name;
        } else {
          let indexes = $.map($scope.items, (obj, k) => {
            if ($scope.selectedItems.indexOf(obj['storage_path']) > -1) {
              return k;
            }
          });
          for (let i = 0; i < indexes.length; i++) {
            selectedStoragePaths.push($scope.items[indexes[i]]._id + ':' + $scope.items[indexes[i]].is_folder);
            names += $rootScope.formatFilename($scope.items[indexes[i]].name, 30) + ', ';
          }
          names = names.substr(0, names.length - 2);
        }
        let messageHtml = '';
        if ($scope.selectedItems.length === 1 || itemScope !== undefined) {
          messageHtml = '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare il file selezionato?';
        } else if ($scope.selectedItems.length > 1) {
          messageHtml = '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare i files selezionati?';
        }
        let modalInstance = $uibModal.open({
          animation: $scope.animationsEnabled,
          component: 'defaultModalComponent',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            config: () => {
              return {
                headerIcon: 'fa fa-exclamation-triangle',
                headerText: 'Attenzione',
                bodyHtml: messageHtml,
                buttons: [
                  {
                    'id': 1,
                    'icon': 'fa fa-ban',
                    'label': 'Annulla'
                  },
                  {
                    'id': 2,
                    'icon': 'fa fa-check-circle-o',
                    'label': 'Si'
                  }
                ]
              };
            }
          }
        });
        modalInstance.result.then((pressedButtonId) => {
          if (pressedButtonId !== undefined && Number(pressedButtonId) === 2) {
            ArchiSmallServices.deleteArchidriveFile(selectedStoragePaths)
              .then((response: any) => {
                let res = response;
                if (res.Result === 1) {
                  $scope.settings.filter.pageNumber = 1;
                  getItems('newSearch');
                }
              }, (error) => {
                if (error.errorCode === $rootScope.ArchiSmallERRORS.ARCHIDRIVE_CANNOT_DELETE_SYSTEM_FOLDER) {
                  $rootScope.alert('error', 'Archivia/Scarica Pacchetti Conservati è una cartella di sistema pertanto non è possibile cancellarla o spostarla');
                }
              });
          }
        }, (error) => {
          // ?
        });
      }
    };

    $scope.getItemByStoragePath = (storage_path) => {
      let indexes = $.map($scope.items, (obj, k) => {
        if (obj['storage_path'] === storage_path) {
          return k;
        }
      });
      if (indexes.length > 0) {
        return $scope.items[indexes[0]];
      }
      return undefined;
    };

    $scope.settings = {
      filter: {
        user: $rootScope.currentUser().sub,
        fileName: $stateParams.file,
        // 'estensione': '',
        dataFrom: '',
        dataTo: '',
        directory: '/',
        pageNumber: 1,
        pageSize: 100
      },
      // sortField: '_id',
      // sortDirection: -1,
      pageSizes: [20, 50, 100]
    };

    $scope.items = [];
    $scope.breadcrumbs = [];
    $scope.currentLocation = '/';
    // </editor-fold>

    $scope.browseItem = ($event, item) => {
      $event.preventDefault();
      $event.stopPropagation();
      if (item.content_type === 'application/x-www-form-urlencoded;charset=UTF-8') {
        $scope.browseFolder($scope.currentLocation + item.name + '/');
      }
    };

    $scope.browseFolder = (directory) => {
      $scope.settings.filter.directory = directory.replace($scope.user.accountData.email + '/archidrive', '');
      $scope.clearFilter();
      event.stopPropagation();
    };

    $scope.clearFilter = () => {
      $scope.settings.filter.fileName = '';
      $scope.settings.filter.dataFrom = '';
      $scope.settings.filter.dataTo = '';
      $scope.settings.filter.pageNumber = 1;
      getItems('newSearch');
    };

    $scope.sortingColumn = 'created_date';
    $scope.sortingAscending = false;

    $scope.sort = (column) => {
      if ($scope.sortingColumn === column) {
        $scope.sortingAscending = !$scope.sortingAscending;
      } else {
        $scope.sortingColumn = column;
      }
    };

    // <editor-fold desc='File Move'>

    $scope.filemouving = false;
    let mousedownPageX = -1;
    let mousedownPageY = -1;

    $scope.mousedown = (event) => {
      let _holderItem: any = ng.element(event.target);
      let holderItem = _holderItem.scope().item;
      if (holderItem !== undefined && holderItem.isSelected === true && event.which === 1) {
        mousedownPageX = event.pageX;
        mousedownPageY = event.pageY;
      }
    };

    let mousemove = (event) => {
      if (!$scope.filemouving && mousedownPageX !== -1 && mousedownPageY !== -1) {
        let mousemovePageX = event.pageX;
        let mousemovePageY = event.pageY;
        let distanceMouseWasDown = Math.sqrt(Math.pow((mousedownPageX - mousemovePageX), 2) + Math.pow((mousedownPageY - mousemovePageY), 2));
        if (distanceMouseWasDown > 2) {
          $timeout(() => {
            $scope.filemouving = true;
          });
        }
      }
      if ($scope.filemouving) {
        $('.accept-drop').removeClass('accept-drop');
        let _holderItem: any = ng.element(event.target);
        let holderItem = _holderItem.scope().item;
        if (holderItem !== undefined && holderItem.content_type === 'application/x-www-form-urlencoded;charset=UTF-8' && holderItem.isSelected !== true) {
          $(event.target).closest('tr').addClass('accept-drop');
        }
        holderItem = _holderItem.scope().breadcrumb;
        if (holderItem !== undefined) {
          let container = $(event.target).closest('li');
          // last LI is not droppable, and is not containing the achor
          if (container.find('a').length) {
            container.addClass('accept-drop');
          }
        }
      }
    };

    $('#multiContent').bind('mousemove', mousemove);
    // $ ('#multiContent').bind('contextmenu', mousemove);

    let moveFiles = (storage_path: any, item?: any) => {
      let filesToMove = [];
      if (item === undefined) {
        for (let i = 0; i < $scope.items.length; i++) {
          if ($scope.items[i].isSelected === true) {
            filesToMove.push($scope.items[i]);
          }
        }
      } else {
        filesToMove.push(item);
      }
      let settings = {
        'filesToMove': filesToMove,
        'destinationFolder': storage_path
      };
      $rootScope.loading = true;
      ArchiSmallServices.moveArchidrive(settings)
        .then((response) => {
          $rootScope.loading = false;
          $scope.settings.filter.pageNumber = 1;
          getItems('newSearch');
        }, (error) => {
          $rootScope.loading = false;
          if (error.errorCode === $rootScope.ArchiSmallERRORS.ARCHIDRIVE_CANNOT_DELETE_SYSTEM_FOLDER) {
            $rootScope.alert('error', 'Archivia/Scarica Pacchetti Conservati è una cartella di sistema pertanto non è possibile cancellarla o spostarla');
          }
        });
    };

    let mouseup = (event) => {
      mousedownPageX = -1;
      mousedownPageY = -1;
      if ($scope.filemouving) {
        $timeout(() => {
          $scope.filemouving = false;
          $('.accept-drop').removeClass('accept-drop');
        });
        let _holderItem: any = ng.element(event.target);
        let holderItem = _holderItem.scope().item;
        if (holderItem !== undefined && holderItem.content_type === 'application/x-www-form-urlencoded;charset=UTF-8' && holderItem.isSelected !== true) {
          moveFiles(holderItem.bucket + '/' + holderItem.parent + holderItem.name + '/');
        }
        holderItem = _holderItem.scope().breadcrumb;
        if (holderItem !== undefined) {
          // we dont move to current location
          if ($scope.currentLocation !== holderItem.directory) {
            moveFiles(holderItem.root);
          }
        }
      }
    };

    $('#multiContent').bind('mouseup', mouseup);
    $('#multiContent').bind('contextmenu', mouseup);
    $scope.mouseup = mouseup;
    $rootScope.disableTextSelectionOnPage = true;

    $scope.$on('$destroy', () => {
      $rootScope.disableTextSelectionOnPage = false;
      $('#multiContent').off('drop.archidrive dragdrop.archidrive dragenter.archidrive dragleave.archidrive dragover.archidrive');

    });
    // </editor-fold>

    // <editor-fold desc='openArchidriveFilterModal'>
    $scope.openArchidriveFilterModal = () => {
      let ArchidriveFilterModalInstance = $uibModal.open({
        animation: true,
        component: 'archidriveFilterComponent',
        size: 'md',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          filter: () => {
            return (jQuery.extend(true, {}, $scope.settings.filter));
          }
        }
      });
      ArchidriveFilterModalInstance.result.then((item) => {
        if (item !== undefined) {
          $scope.settings.filter = item;
          $scope.settings.filter.directory = '/';
          $scope.settings.filter.pageNumber = 1;
          getItems('newSearch');
        }
      }, (error) => {
        // ?
      });
    };
    // </editor-fold>

    // <editor-fold desc='openArchidriveNewFolder'>
    $scope.openArchidriveNewFolder = () => {
      let ArchidriveNewFolderModalInstance = $uibModal.open({
        animation: true,
        component: 'archidriveNewFolderComponent',
        size: 'md',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          path: () => {
            return 'Archivia' + $scope.currentLocation;
          }
        }
      });
      ArchidriveNewFolderModalInstance.result.then((item) => {
        if (item !== undefined) {
          let username = $rootScope.currentUser().sub;
          let settings = 'username=' + username + '&directoryPath=' + $scope.currentLocation + item;
          ArchiSmallServices.createArchidriveDirectory(settings)
            .then((response) => {
              $scope.settings.filter.pageNumber = 1;
              getItems('newSearch');
            }, (error) => {
              $rootScope.alert('error', error);
            });
        }
      }, (error) => {
        // ?
      });
    };
    // </editor-fold>

    // <editor-fold desc='openArchidriveRename'>
    $scope.openArchidriveRename = (itemScope) => {
      if (itemScope !== undefined || $scope.selectedItems.length === 1) {
        let item = itemScope !== undefined ? itemScope : $scope.getItemByStoragePath($scope.selectedItems[0]);
        let ArchidriveRenameModalInstance = $uibModal.open({
          animation: true,
          component: 'archidriveRenameComponent',
          size: 'md',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            item: () => {
              return item;
            }
          }
        });
        ArchidriveRenameModalInstance.result.then((newName) => {
          if (newName !== undefined) {

            let settings = {
              'newName': newName,
              '_id': item._id,
              'isFolder': item.is_folder
            };
            ArchiSmallServices.renameArchidriveFile(settings)
              .then((response) => {
                $scope.settings.filter.pageNumber = 1;
                getItems('newSearch');
              }, (error) => {
                if (error.errorCode === $rootScope.ArchiSmallERRORS.ARCHIDRIVE_CANNOT_DELETE_SYSTEM_FOLDER) {
                  $rootScope.alert('error', 'Archivia/Scarica Pacchetti Conservati è una cartella di sistema pertanto non è possibile cancellarla o spostarla');
                }

              });
          }
        }, (error) => {
          // ?
        });
      }
    };
    // </editor-fold>

    // <editor-fold desc='Sposta'>
    $scope.sposta = (itemScope) => {
      if (itemScope !== undefined || $scope.selectedItems.length > 0) {
        let ArchidriveMoveModalInstance = $uibModal.open({
          animation: true,
          component: 'archidriveMoveComponent',
          size: 'md',
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            mouvingItems: () => {
              let mouvingItems = [];
              if (itemScope === undefined) {

                let indexes = $.map($scope.items, (obj, k) => {
                  if ($scope.selectedItems.indexOf(obj['storage_path']) > -1) {
                    return k;
                  }
                });

                for (let i = 0; i < indexes.length; i++) {
                  mouvingItems.push($scope.items[indexes[i]]);
                }

              } else {
                mouvingItems.push(itemScope);
              }

              return mouvingItems;
            },
            currentLocation: () => {
              return $scope.currentLocation;
            }
          }
        });
        ArchidriveMoveModalInstance.result.then((item) => {
          if (item !== undefined) {
            if ($scope.currentLocation !== item.relativePath) {
              let relativePath = item.relativePath;
              if (relativePath.indexOf('/') === 0) {
                relativePath = relativePath.substr(1);
              }

              if (itemScope === undefined) {
                moveFiles(item.archiDriveRootPath + relativePath);
              } else {
                moveFiles(item.archiDriveRootPath + relativePath, itemScope);
              }
            }
          }
        });
      }
    };
    // </editor-fold>

    let uploadFileOnGoogleStorageProgressCallback = (x) => {
      if ($scope.uploadQueue.length > 0) {
        $timeout(() => {
          if ($scope.uploadQueue[0] !== undefined) {
            $scope.uploadQueue[0].progress = x;
          }
        });
      } else if ($scope.uploadQueue.length === 0) {
        $rootScope.archiviaUploadInProgress = false;
      }
    };

    let uploading = false;
    let uploadFileOnGoogleStorage = () => {
      if ($scope.uploadQueue.length > 0 && !uploading) {

        // user max upload size check
        if (($scope.uploadQueue[0].size / 1024 / 1024) > $rootScope.user.limits.maxFileSizeOnUploadMB) {
          let fileName = $scope.uploadQueue[0].name;
          $rootScope.alert('error', 'Il file ' + fileName + ' supera il limite di dimensione massimo consentito per l\'upload un singolo file (' + $rootScope.user.limits.maxFileSizeOnUploadMB + ' MB). Se desideri incrementare questo limite puoi contattare il supporto ArchiSMALL.');
          $scope.uploadQueue.shift();

          uploadFileOnGoogleStorage();
          return;
        }

        if ($scope.uploadQueue[0].size === 0) {
          let fileName = $scope.uploadQueue[0].name;
          $scope.uploadQueue.shift();
          $rootScope.alert('warning', 'Il file <i>' + fileName + '</i> è vuoto! Non è possibile caricarlo in Archivio.'); // attenzione! Il file che stai archiviando è vuoto! Non è possibile caricarlo in Archivio.

          if ($scope.uploadQueue.length === 0) {
            return;
          }
        }

        // usage Percentage check
        ArchiSmallServices.getStorageUsage()
          .then((response) => {
            $rootScope.storageUsage = response;
            console.log('storagePercentage', $rootScope.storageUsage);
            if ($rootScope.storageUsage.usagePercentage >= 100 && $rootScope.storageUsage.isBlockUser) {
              $rootScope.alert('error', 'Hai esaurito lo spazio a disposizione (' + $rootScope.storageUsage.availableSpace + '). Richiedei un incremento di spazio contattando il supporto ArchiSMALL.');
              $scope.uploadQueue = [];
              return;
            }
            ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
              .then((response) => {
                uploading = true;
                // TODO implement insertObjectInChunks
                googleAPI.insertObject($scope.uploadQueue[0], $scope.uploadQueue[0].dropzoneId, $scope.uploadQueue[0].storageFolder, '', $scope.uploadFileOnGoogleStorageCallback, uploadFileOnGoogleStorageProgressCallback, $scope.uploadQueue[0].bucket, $scope.fileNamesToUpload, archiDriveUploadRootPath);

              }, (error) => {
                ArchiSmallServices.getGoogleAPIToken()
                  .then((response: any) => {
                    uploading = true;
                    googleAPI.setAccessToken(response.accessToken);
                    // TODO implement insertObjectInChunks
                    googleAPI.insertObject($scope.uploadQueue[0], $scope.uploadQueue[0].dropzoneId, $scope.uploadQueue[0].storageFolder, '', $scope.uploadFileOnGoogleStorageCallback, uploadFileOnGoogleStorageProgressCallback, $scope.uploadQueue[0].bucket, $scope.fileNamesToUpload, archiDriveUploadRootPath);

                  }, (error) => {
                    $rootScope.alert('error', error);
                    uploading = false;

                  });
              });
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };


    // <editor-fold desc='Upload'>
    $scope.uploadQueue = [];
    $scope.uploadFileOnGoogleStorageCallback = (dropzoneId, res, filename) => {
      $scope.uploadQueue.shift();
      // dropzoneId == false means
      // file was canceled or there was an error uploading it
      if (dropzoneId !== false) {
        $scope.settings.filter.pageNumber = 1;
        getItems('newSearch');
        // $('.archidrive .new-file button').focus();
      }
      uploading = false;
      $timeout(() => {
        uploadFileOnGoogleStorage();
      });
    };

    $scope.startInputUpload = () => {
      $('#input-upload').trigger('click');
    };
    $scope.cancelUpload = (file) => {
      file.cancelled = true;
      $('.accept-drop').removeClass('accept-drop');
    };

    let verifyFiles = (files) => {

      return true;
    };

    $scope.inputUpload = (input) => {
      if (!verifyFiles(input.files)) {
        return false;
      }

      $rootScope.archiviaUploadInProgress = true;
      let files = input.files;
      $scope.originalFileNames = [];

      for (let index = 0; index < files.length; index++) {
        let file = files[index];
        file.progress = 0;
        file.bucket = archiDriveRootPath.substr(0, archiDriveRootPath.indexOf('/'));
        file.storageFolder = archiDriveRootPath.substr(archiDriveRootPath.indexOf('/') + 1);


        let basePath = file.storageFolder;
        let fileName = file.name;

        let fileItem = {
          'basePath': basePath,
          'filename': fileName
        };

        $scope.originalFileNames.push(fileItem);

        $scope.uploadQueue.push(file);
      }
      let $input = $(input);
      $input.wrap('<form>').closest('form').get(0).reset();
      $input.unwrap();
      $scope.filesToUpload = {
        'files': $scope.originalFileNames
      };

      ArchiSmallServices.getUploadFilenames($scope.filesToUpload)
        .then((response) => {
          if (response !== undefined) {
            if ($rootScope.archiviaUploadInProgress && $scope.fileNamesToUpload !== undefined) {
              ng.extend($scope.fileNamesToUpload, response[0]);
            } else {
              $scope.fileNamesToUpload = response[0];
            }

            uploadFileOnGoogleStorage();
          }
        });
    };

    let counterDragEnterLeave = 0;
    let counterDragEnterLeaveByElements = {};
    // http://stackoverflow.com/questions/7110353/html5-dragleave-fired-when-hovering-a-child-element
    let dropUpload = (event) => {
      $rootScope.archiviaUploadInProgress = true;
      $scope.originalFileNames = [];
      $('.accept-drop').removeClass('accept-drop');
      counterDragEnterLeaveByElements = {};
      if (event !== null) {
        event.preventDefault();
        event.stopPropagation();
      }
      let files = event.originalEvent.dataTransfer.files;
      $('.external-drop-indicator').css('display', 'none');
      counterDragEnterLeave = 0;
      if (!verifyFiles(files)) {
        return false;
      }

      let bucket = archiDriveRootPath.substr(0, archiDriveRootPath.indexOf('/'));
      let storageFolder = archiDriveRootPath.substr(archiDriveRootPath.indexOf('/') + 1);
      let _holderItem: any = ng.element(event.target);
      let holderItem = _holderItem.scope().item;
      if (holderItem !== undefined && holderItem.content_type === 'application/x-www-form-urlencoded;charset=UTF-8') {
        storageFolder = holderItem.storage_path.substr(holderItem.storage_path.indexOf('/') + 1);
        if (storageFolder.lastIndexOf('/') === storageFolder.length - 1) {
          storageFolder = storageFolder.slice(0, -1);
        }
      }
      holderItem = _holderItem.scope().breadcrumb;
      if (holderItem !== undefined) {
        let container = $(event.target).closest('li');
        // last LI is not droppable, and is not containing the achor
        if (container.find('a').length) {
          storageFolder = holderItem.root.substr(holderItem.root.indexOf('/') + 1);
          if (storageFolder.lastIndexOf('/') === storageFolder.length - 1) {
            storageFolder = storageFolder.slice(0, -1);
          }
        }
      }

      for (let index = 0; index < files.length; index++) {
        let file = files[index];
        file.progress = 0;
        file.bucket = bucket;
        file.storageFolder = storageFolder;

        let basePath = file.storageFolder;
        let fileName = file.name;

        let fileItem = {
          'basePath': basePath,
          'filename': fileName
        };

        $scope.originalFileNames.push(fileItem);

        $scope.uploadQueue.push(file);
      }
      $scope.$apply();

      $scope.filesToUpload = {
        'files': $scope.originalFileNames
      };

      ArchiSmallServices.getUploadFilenames($scope.filesToUpload)
        .then((response) => {
          if (response !== undefined) {

            if ($rootScope.archiviaUploadInProgress && $scope.fileNamesToUpload !== undefined) {
              ng.extend($scope.fileNamesToUpload, response[0]);
            } else {
              $scope.fileNamesToUpload = response[0];
            }

            uploadFileOnGoogleStorage();
          }
        });
    };


    $('#multiContent').on('drop.archidrive dragdrop.archidrive', dropUpload);
    $('#multiContent').on('dragenter.archidrive', (event) => {
      event.preventDefault();
      counterDragEnterLeave++;
      $('.external-drop-indicator').css('display', 'block');
      let _holderItem: any = ng.element(event.target);
      let holderItem = _holderItem.scope().item;
      if (holderItem !== undefined && holderItem.content_type === 'application/x-www-form-urlencoded;charset=UTF-8') {
        if (counterDragEnterLeaveByElements[holderItem.storage_path] === undefined) {
          counterDragEnterLeaveByElements[holderItem.storage_path] = 1;
        } else {
          counterDragEnterLeaveByElements[holderItem.storage_path]++;
        }
        $(event.target).closest('tr').addClass('accept-drop');
      }

      holderItem = _holderItem.scope().breadcrumb;
      if (holderItem !== undefined) {
        let container = $(event.target).closest('li');
        // last LI is not droppable, and is not containing the achor
        if (container.find('a').length) {

          if (counterDragEnterLeaveByElements[holderItem.directory] === undefined) {
            counterDragEnterLeaveByElements[holderItem.directory] = 1;
          } else {
            counterDragEnterLeaveByElements[holderItem.directory]++;
          }

          container.addClass('accept-drop');
        }
      }
    });

    $('#multiContent').on('dragleave.archidrive', (event) => {
      counterDragEnterLeave--;
      if (counterDragEnterLeave <= 0) {
        $('.external-drop-indicator').css('display', 'none');
      }

      let _holderItem: any = ng.element(event.target);
      let holderItem = _holderItem.scope().item;
      if (holderItem !== undefined && holderItem.content_type === 'application/x-www-form-urlencoded;charset=UTF-8') {
        counterDragEnterLeaveByElements[holderItem.storage_path]--;
        if (counterDragEnterLeaveByElements[holderItem.storage_path] <= 0) {
          $(event.target).closest('tr').removeClass('accept-drop');
        }
      }

      holderItem = _holderItem.scope().breadcrumb;
      if (holderItem !== undefined) {
        let container = $(event.target).closest('li');
        // last LI is not droppable, and is not containing the achor
        if (container.find('a').length) {
          counterDragEnterLeaveByElements[holderItem.directory]--;
          if (counterDragEnterLeaveByElements[holderItem.directory] <= 0) {
            container.removeClass('accept-drop');
          }
        }
      }
    });
    $('#multiContent').on('dragover.archidrive', (event) => {
      event.preventDefault();
    });
    // </editor-fold>

    let isFolderSelected = (itemScope) => {
      if ($scope.items && $scope.selectedItems && $scope.selectedItems.length > 0) {

        // find selected items with metadata.complete_status = 0
        let invalidItemsIndexes = $.map($scope.items, (obj, index) => {
          if (obj.is_folder === true && $.inArray(obj.storage_path, $scope.selectedItems) > -1) {
            return index;
          }
        });
        return invalidItemsIndexes.length > 0;
      } else if ($scope.items && itemScope !== undefined) {
        return itemScope.is_folder === true;
      }

      return false;
    };

    // <editor-fold desc='openShareModal'>
    $scope.openShareModal = (itemscope) => {
      let selectedFiles = [];

      if (isFolderSelected(itemscope)) {
        $rootScope.alert('warning', 'Hai selezionato una o più cartelle.\nPuoi condividere soltanto i files.');
        return;
      }

      if (itemscope !== undefined) {
        selectedFiles.push(itemscope.storage_path);
      } else {
        selectedFiles = $scope.selectedItems;
      }

      let ArchidriveShareModalInstance = $uibModal.open({
        animation: true,
        component: 'archidriveShareComponent',
        size: 'xs',
        scope: $scope,
        windowClass: 'center-modal',
        // backdrop: 'static',
        // keyboard: false,
        resolve: {
          selectedItems: () => {
            return selectedFiles;
          },
          items: () => {
            return $scope.items;
          }
        }
      });
      ArchidriveShareModalInstance.result.then(() => {
        $scope.user = store.get('user');
      });
    };
    // </editor-fold>

    getItems();

    $scope.contextMenuOptions = (item) => {
      if ($scope.selectedItems.length > 1) {
        $scope.menuOptionsMultiple[0][0] = '<span><strong>Documenti multipli (' + $scope.selectedItems.length + ')</strong></span>';

        return $scope.menuOptionsMultiple;
      } else {
        let filenameLength = item.name.length;
        let filename = '';
        if (filenameLength > 23) {
          filename = item.name.substr(0, 10).trim() + '...' + item.name.substr(filenameLength - 10, filenameLength).trim();
        }

        filename = filename !== '' ? filename : item.name;
        if (item.content_type !== 'application/x-www-form-urlencoded;charset=UTF-8') {
          $scope.menuOptionsSingleFile[0][0] = '<span><strong>' + filename + '</strong></span>';
          return $scope.menuOptionsSingleFile;
        } else if (item.content_type === 'application/x-www-form-urlencoded;charset=UTF-8') {
          $scope.menuOptionsSingleFolder[0][0] = '<span><strong>' + filename + '</strong></span>';
          return $scope.menuOptionsSingleFolder;
        }
      }
    };

    $scope.contextMenuItemNewFolder = '<i class=\'icon - icon_add_cartella\'></i> <span>Crea Cartella</span>';
    $scope.contextMenuItemNewFile = '<i class=\'icon - icon_add_file\'></i> <span>Carica</span>';
    $scope.contextMenuItemDownload = '<i class=\'icon - icon_scarica\'></i> <span>Scarica</span>';
    $scope.contextMenuItemShare = '<i class=\'icon - icon_condividi\'></i> <span>Condividi</span>';
    $scope.contextMenuItemRename = '<i class=\'icon - icon_modifica\'></i> <span>Rinomina</span>';
    $scope.contextMenuItemRemove = '<i class=\'icon - icon_erase\'></i> <span>Rimuovi</span>';
    $scope.contextMenuItemMove = '<i class=\'fa fa - arrows\'></i> <span>Sposta</span>';
    $scope.contextMenuItemPreview = '<i class=\'fa fa - eye\'></i> <span>Anteprima</span>';

    $scope.menuOptionsSingleFolder = [
      [$scope.contextMenuItemTitle, () => {
        //
      }],
      null,
      [$scope.contextMenuItemNewFolder, () => {
        $scope.openArchidriveNewFolder();
      }],
      null,
      [$scope.contextMenuItemNewFile, () => {
        $scope.startInputUpload();
      }],
      null,
      [$scope.contextMenuItemShare, ($itemScope) => {
        $scope.openShareModal($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemRename, ($itemScope) => {
        $scope.openArchidriveRename($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemRemove, ($itemScope) => {
        $scope.delete($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemMove, ($itemScope) => {
        $scope.sposta($itemScope.item);
      }]
    ];

    $scope.menuOptionsSingleFile = [
      [$scope.contextMenuItemTitle, ($itemScope) => {
        //
      }],
      null,
      [$scope.contextMenuItemNewFolder, ($itemScope) => {
        $scope.openArchidriveNewFolder();
      }],
      null,
      [$scope.contextMenuItemNewFile, ($itemScope) => {
        $scope.startInputUpload();
      }],
      null,
      [$scope.contextMenuItemDownload, ($itemScope) => {
        $scope.download($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemShare, ($itemScope) => {
        $scope.openShareModal($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemRename, ($itemScope) => {
        $scope.openArchidriveRename($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemRemove, ($itemScope) => {
        $scope.delete($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemMove, ($itemScope) => {
        $scope.sposta($itemScope.item);
      }],
      null,
      [$scope.contextMenuItemPreview, ($itemScope) => {
        PreviewService.showPreview($itemScope.item, $scope.previewModal);
      }]
    ];

    $scope.menuOptionsMultiple = [
      [$scope.contextMenuItemTitle, () => {
        // title
      }],
      null,
      [$scope.contextMenuItemNewFolder, () => {
        $scope.openArchidriveNewFolder();
      }],
      null,
      [$scope.contextMenuItemNewFile, () => {
        $scope.startInputUpload();
      }],
      null,
      [$scope.contextMenuItemShare, () => {
        $scope.openShareModal();
      }],
      null,
      [$scope.contextMenuItemRemove, () => {
        $scope.delete();
      }],
      null,
      [$scope.contextMenuItemMove, () => {
        $scope.sposta();
      }]
    ];
    // </editor-fold>

    $scope.addOrRemoveSelectedItems = (item) => {
      if (item.isSelected) {
        if ($scope.selectedItems.indexOf(item.storage_path) === -1) {
          $scope.selectedItems.push(item.storage_path);
        }
        if ($scope.selectedItems.length === 1) {
          $scope.selectedItem = item;
        }
      } else {
        if ($scope.selectedItems.length !== 1) {
          let index = $scope.selectedItems.indexOf(item.storage_path);
          $scope.selectedItems.splice(index, 1);
        }
      }
    };

    $scope.getFilesFromSelectedItems = () => {
      let files = $.map($scope.items, (obj, index) => {
        if ($.inArray(obj.storage_path, $scope.selectedItems) > -1) {
          return obj;
        }
      });

      return files;
    };

    $scope.previewModal = (item, type, size) => {
      let previewModalInstance = $uibModal.open({
        animation: true,
        component: 'previewModalComponent',
        controllerAs: 'vm',
        size: 'preview',
        resolve: {
          path: () => {
            return item.storage_path;
          },
          type: () => {
            return type;
          }
        }
      });
    };

  }

  isEdge(): boolean {
    return appContext.userBrowser.isEdge;
  }

}

export const ArchidriveComponent: ng.IComponentOptions = {
  template: require('./archidrive.html'),
  controller: ArchidriveController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive.ts